import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4063db97&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=4063db97&prod&lang=scss"
import style1 from "./Footer.vue?vue&type=style&index=1&id=4063db97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4063db97",
  null
  
)

export default component.exports